import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { LayoutGrid } from "lucide-react";
import { useApp } from "@/context";
import { optimizeImg } from "@/lib/img";

const isTest = (s) => /test|اختبار/i.test(String(s || ""));

/* مربع قسم مدمج بأسلوب طلبات: بطاقة بيج ناعمة + الاسم تحتها */
export function DeptTile({ t }) {
  const [ok, setOk] = useState(true);
  return (
    <Link to={t.to} data-testid={t.testid}
          className="flex flex-col items-center gap-1.5 active:scale-95 transition-transform">
      <span className="w-full aspect-square rounded-2xl overflow-hidden flex items-center justify-center"
            style={{ background: "#F3EDE3", border: "1px solid rgba(0,0,0,0.04)" }}>
        {t.image && ok ? (
          <img src={optimizeImg(t.image, 240)} alt={t.label} loading="lazy" decoding="async"
               onError={() => setOk(false)} className="w-full h-full object-cover" />
        ) : (
          <span className="text-2xl sm:text-3xl select-none">{t.icon}</span>
        )}
      </span>
      <span className="text-[10.5px] sm:text-xs font-bold text-center leading-tight w-full truncate">
        {t.label}
      </span>
    </Link>
  );
}

export const deptToTile = (d, ar) => ({
  key: `dept-${d.slug}`, to: `/shop?department=${d.slug}`,
  label: ar ? d.name_ar : d.name_en || d.name_ar,
  image: d.cover_image || d.image || "", icon: d.icon || "🎁",
  testid: `cat-tile-dept-${d.slug}`,
});

/* الرئيسية المخففة: صفّان × 5 فقط — أبرز 9 أقسام + مربع «الكل» (بدل 7 صفحات سحب) */
export default function HomeDepartments({ departments = [] }) {
  const { lang } = useApp();
  const ar = lang === "ar";

  const { tiles, rest } = useMemo(() => {
    const clean = departments.filter((d) => !isTest(d.slug) && !isTest(d.name_ar));
    let featured = clean.filter((d) => d.home_featured);
    if (featured.length < 4) featured = clean;
    featured = featured.slice(0, 9);
    return { tiles: featured.map((d) => deptToTile(d, ar)), rest: Math.max(0, clean.length - featured.length) };
  }, [departments, ar]);

  if (!tiles.length) return null;
  return (
    <section data-testid="home-depts-featured">
      <div className="grid grid-cols-5 lg:grid-cols-10 gap-2 sm:gap-3">
        {tiles.map((t) => <DeptTile key={t.key} t={t} />)}
        <Link to="/departments" data-testid="home-all-depts-tile"
              className="flex flex-col items-center gap-1.5 active:scale-95 transition-transform">
          <span className="w-full aspect-square rounded-2xl flex flex-col items-center justify-center gap-0.5 text-white"
                style={{ background: "var(--primary, #11392A)" }}>
            <LayoutGrid size={20} strokeWidth={1.8} />
            {rest > 0 && <span className="text-[10px] font-bold opacity-85">+{rest}</span>}
          </span>
          <span className="text-[10.5px] sm:text-xs font-bold text-center leading-tight w-full truncate">
            {ar ? "الكل" : "All"}
          </span>
        </Link>
      </div>
    </section>
  );
}
